module.exports = __webpack_public_path__ + "img/nasa-08-rose.d4439e2c.svg";